import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useNavigate, useParams } from "react-router-dom";
import FormField from "layouts/pages/account/components/FormField";
import SoftButton from "components/SoftButton";
import { useTranslation } from "react-i18next";
import BankApi from "api/bank";

function EditBank() {
  const { t } = useTranslation();
  const { bankId } = useParams();
  const [bank, setBank] = useState({
    name: "",
    numAccount: "",
    createdAt: "",
    address: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    BankApi.GetBankById(token, bankId)
      .then((res) => {
        const data = res.data.bank;
        setBank({
          name: data.name || "",
          numAccount: data.swift_code || "",
          createdAt: data.created_at || "",
          address: data.address || "",
        });
      })
      .catch((err) => console.error(err));
  }, [bankId]);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setBank({ ...bank, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) return;

    const updatedBank = {
      name: bank.name,
      num_account: bank.numAccount,
      address: bank.address,
      created_at: bank.createdAt,
    };

    BankApi.UpdateBank(token, bankId, updatedBank)
      .then(() => {
        navigate("/gestion-financiere/liste-des-banques");
      })
      .catch((err) => {
        console.error(err.response?.data || err.message);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        minHeight="85vh"
      >
        <SoftBox py={2}>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <SoftTypography variant="h5" gutterBottom pb={5} pt={2}>
                    {t("Modifier la banque")}
                  </SoftTypography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <FormField
                        fullWidth
                        label={t("Nom")}
                        name="name"
                        value={bank.name}
                        onChange={handleChange}
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormField
                        fullWidth
                        label={t("Numéro de compte")}
                        name="numAccount"
                        value={bank.numAccount}
                        onChange={handleChange}
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormField
                        fullWidth
                        label={t("Adresse")}
                        name="address"
                        value={bank.address}
                        onChange={handleChange}
                        required
                      />
                    </Grid>

                    {/* <Grid item xs={12}>
                      <FormField
                        fullWidth
                        label={t("Date de création")}
                        name="createdAt"
                        type="date"
                        value={bank.createdAt}
                        onChange={handleChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                      />
                    </Grid> */}

                    <Grid item xs={12} display="flex" justifyContent="flex-end">
                      <SoftButton
                        type="submit"
                        variant="contained"
                        color="info"
                        onClick={handleSubmit}
                      >
                        {t("Modifier la banque")}
                      </SoftButton>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </SoftBox>
        <Footer />
      </SoftBox>
    </DashboardLayout>
  );
}

export default EditBank;
